if (!customElements.get('home-newarrivals')) {
  // 注册自定义元素
  customElements.define("home-newarrivals", class HomeNewarrivals extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('DOMContentLoaded', () => {
        this.observeElement(this, this.handleInViewport.bind(this));
      });
    }

    handleInViewport() {
      // 初始化元素
      this.init();
      // 添加 resize 事件监听器
      this.resizeListener = this.debounce(this.handleResize.bind(this), 200);
      window.addEventListener('resize', this.resizeListener);
    }

    observeElement(element, callback) {
      // 创建一个 IntersectionObserver 实例
      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            callback();
            // 只执行一次，停止观察
            observerInstance.unobserve(entry.target);
          }
        });
      }, {
        // 视口外 1/2 高度以内触发
        root: null,
        threshold: 0.5
      });
      // 如果已经在视口内,立即执行回调
      if (this.isElementInViewport(element)) {
        callback();
        return;
      }
      observer.observe(element);
    }

    // 判断元素是否在视口内
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= -el.offsetHeight / 2 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight / 2
      );
    }

    disconnectedCallback() {
      // 元素从DOM中移除时调用
      // 移除 slick 实例
      this.destroySlick(homeNewArrivalList);
      // 移除 resize 事件监听器
      window.removeEventListener('resize', this.resizeListener);
    }

    init() {
      setTimeout(() => {
        this.handleResize(); // 初始化时也执行一次 handleResize
      }, 0);
    }

    handleResize() {
      let homeNewArrivalList = $(this.querySelector('.prolist-wrapper'));
      this.initSlick(homeNewArrivalList);
      // this.itemheight();
    }

    initSlick(homeNewArrivalList) {
      if (homeNewArrivalList?.hasClass('slick-initialized')) {
        homeNewArrivalList.slick('unslick');
      }
      homeNewArrivalList?.slick({
        infinite: true,
        draggable: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="home-newarrivals-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="home-newarrivals-prev">Home Newarrivals Prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
        nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="home-newarrivals-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="home-newarrivals-next">Home Newarrivals Next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 590,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false,
              dots: true,
            },
          },
        ]
      });
    }

    // itemheight() {
    //   let height = 0;
    //   this.querySelectorAll(`.card__content`)?.forEach((el) => {
    //     if(height < el.getBoundingClientRect().height){height = el.getBoundingClientRect().height;}
    //   });
    //   let maxH = Math.ceil(height + 20);
    //   this.querySelectorAll(`.card__content`)?.forEach(el => el.style.height = `${maxH}px`);
    // }

    destroySlick(homeNewArrivalList = $(this.querySelector('.prolist-wrapper'))) {
      if (homeNewArrivalList?.hasClass('slick-initialized')) {
        homeNewArrivalList.slick('unslick');
      }
    }

    debounce(func, wait) {
      let timeout;
      return function (...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  });
}
